<template>
  <div class="gold__selfSelectGoldAmountContent">
    <button
      class="gold__selfSelectGoldAmountButton gold__selfSelectGoldAmountButton--pc"
      v-longclick="decreaseValue"
      @click.prevent="decreaseValue"
      v-on:contextmenu.prevent
      v-on:touchstart="enterButton"
      v-on:mousedown="enterButton"
      v-on:touchend="leaveButton"
      v-on:mouseup="leaveButton"
      :class="{ 'gold__selfSelectGoldAmountButton--disable': isMin }"
    >
      −<vc-number-format :amount="amount_unit"></vc-number-format>
    </button>
    <div class="gold__selfSelectGoldAmountLabel">
      <input
        class="gold__amountRadio"
        id="amount-self"
        type="radio"
        name="amount"
        ref="amountSelf"
        :value="amount_num"
      />
      <label class="gold__amountRadioLabel" for="amount-self"
        ><span
          ><vc-number-format :amount="amount_num"></vc-number-format>&nbsp;{{
            goldUnit
          }}</span
        ></label
      >
    </div>
    <button
      class="gold__selfSelectGoldAmountButton gold__selfSelectGoldAmountButton--pc"
      v-longclick="increaseValue"
      @click.prevent="increaseValue"
      v-on:contextmenu.prevent
      v-on:touchstart="enterButton"
      v-on:mousedown="enterButton"
      v-on:touchend="leaveButton"
      v-on:mouseup="leaveButton"
      :class="{ 'gold__selfSelectGoldAmountButton--disable': isMax }"
    >
      +<vc-number-format :amount="amount_unit"></vc-number-format>
    </button>
    <div class="gold__selfSelectGoldAmountButtons">
      <button
        class="gold__selfSelectGoldAmountButton gold__selfSelectGoldAmountButton--sp"
        v-longclick="decreaseValue"
        @click.prevent="decreaseValue"
        v-on:contextmenu.prevent
        v-on:touchstart="enterButton"
        v-on:mousedown="enterButton"
        v-on:touchend="leaveButton"
        v-on:mouseup="leaveButton"
        :class="{ 'gold__selfSelectGoldAmountButton--disable': isMin }"
      >
        −<vc-number-format :amount="amount_unit"></vc-number-format>
      </button>
      <button
        class="gold__selfSelectGoldAmountButton gold__selfSelectGoldAmountButton--sp"
        v-longclick="increaseValue"
        @click.prevent="increaseValue"
        v-on:contextmenu.prevent
        v-on:touchstart="enterButton"
        v-on:mousedown="enterButton"
        v-on:touchend="leaveButton"
        v-on:mouseup="leaveButton"
        :class="{ 'gold__selfSelectGoldAmountButton--disable': isMax }"
      >
        +<vc-number-format :amount="amount_unit"></vc-number-format>
      </button>
    </div>
  </div>
</template>

<script>
import Vue, { PropType } from "vue";
import { longClickDirective } from "vue-long-click";
import Locale from "@/lib/locale";

const longClickInstance = longClickDirective({ delay: 400, interval: 50 });
Vue.directive("longclick", longClickInstance);

export default Vue.extend({
  name: "vc-self-select-gold-amount",
  props: {
    goldUnit: {
      type: String,
      default: "GOLD"
    }
  },
  data() {
    return {
      locale: Locale.getLocale(),
      amount_unit: 500,
      amount_num: 1500,
      max_amount: 49500,
      min_amount: 500
    };
  },
  computed: {
    isMax() {
      return this.max_amount === this.amount_num;
    },
    isMin() {
      return this.min_amount === this.amount_num;
    }
  },
  methods: {
    decreaseValue() {
      this.changeValue(-this.amount_unit);
    },
    increaseValue() {
      this.changeValue(this.amount_unit);
    },
    changeTarget() {
      const target = this.$refs.amountSelf;
      if (target.checked !== undefined) {
        target.checked = true;
      }
    },
    changeUserSelect(isActive) {
      // iOS端末で[+500/-500]ボタン長押し時に、長押しによるテキスト選択状態になることを防ぐ PAY-1184
      if (isActive) {
        window.body.classList.add("userSelectNone");
      } else {
        window.body.classList.remove("userSelectNone");
      }
    },
    enterButton() {
      this.changeTarget();
      this.changeUserSelect(true);
    },
    leaveButton() {
      this.changeUserSelect(false);
    },
    changeValue(amount) {
      if ((this.isMin && amount < 0) || (this.isMax && amount > 0)) return;
      this.amount_num = this.amount_num + amount;
    }
  }
});
</script>
